
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SASOLDH',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SASOLDH.vue